import { useTranslation } from "@outschool/localization";
import { dayjs, isToday } from "@outschool/time";

/**
 * A drop-in replacement for `shared/hooks/useSectionString.ts` functions that supports translation.
 * TODO: we only support a subset of the useSectionString API so far
 */
export default function useSectionString() {
  const { t } = useTranslation(
    "ui-components-website\\hooks\\useSectionString"
  );

  const formatNextSessionStartTime = (
    date: string,
    timeZone: string
  ): string | null => {
    const currentDate = dayjs().tz(timeZone);
    const sessionDate = dayjs(date).tz(timeZone);
    const minutesFromNow = sessionDate.diff(currentDate, "minutes");

    if (minutesFromNow < 0) {
      return null;
    } else if (minutesFromNow < 3) {
      return t("Next session starting now");
    } else if (minutesFromNow <= 30) {
      return t("Next session in {{minutesFromNow}} minutes", {
        minutesFromNow,
      });
    } else if (isToday(sessionDate.toISOString(), timeZone)) {
      return t("Next session at {{sessionTime}} today", {
        sessionTime: sessionDate.format("LT").replace(":00", ""),
      });
    } else if (currentDate.add(1, "day").isSame(sessionDate, "day")) {
      return t("Next session at {{sessionTime}} tomorrow", {
        sessionTime: sessionDate.format("LT").replace(":00", ""),
      });
    } else if (currentDate.add(6, "day").isSameOrAfter(sessionDate, "day")) {
      return t("Next session at {{sessionTime}} on {{sessionDate}}", {
        sessionTime: sessionDate.format("LT").replace(":00", ""),
        sessionDate: sessionDate.format("dddd"),
      });
    } else {
      return t("Next session at {{sessionTime}} on {{sessionDate}}", {
        sessionTime: sessionDate.format("LT").replace(":00", ""),
        sessionDate: sessionDate.format("ddd M/D"),
      });
    }
  };

  return {
    formatNextSessionStartTime,
  };
}
